import { Observable, Subject } from 'rxjs/Rx';
import { Kursant } from '../services/kursant';
import { AngularFireList } from 'angularfire2/database/interfaces';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { KursanciService } from '../services/kursanci.service';

@Component({
  selector: 'app-kursanci',
  templateUrl: './kursanci.component.html',
  styleUrls: ['./kursanci.component.scss']
})
export class KursanciComponent implements OnInit {

    kursanci$: Kursant[];
    filteredKursanci$: Kursant[];
    kursanciRef;
    curPage : number;
    pageSize : number;
    
  constructor(private kursanciService: KursanciService) { }

  ngOnInit() {
    this.kursanciRef = this.kursanciService.getKursanci();
    this.kursanci$ = this.kursanciRef.snapshotChanges().map(actions => {
            return actions.map(action => {
              const data = action.payload.val() as Kursant;
              const key = action.payload.key;
              return { key, ...data };
            })
        })
        .subscribe(kursanci => this.filteredKursanci$ = this.kursanci$ = kursanci)
        // .do( res => console.log('findKursanci:', res))

        this.curPage = 1;
        this.pageSize = 10;

    };

    // ngOnDestroy(){
    //     this.kursanciRef.snapshotChanges().unsubscribe;  // ????
    // };
  
    search(query: string) {
        this.filteredKursanci$ = (query) ?
            this.kursanci$.filter(p => p.nazwisko.toLowerCase().includes(query.toLowerCase())) :
            this.kursanci$;
    };
    
    numberOfPages(){
        return Math.ceil(this.filteredKursanci$.length / this.pageSize);
      };
}



// WEBPACK FOOTER //
// ./src/app/kursanci/kursanci.component.ts